export const IMAGES = {
  heroSplash: "https://images.pexels.com/photos/6233583/pexels-photo-6233583.jpeg?auto=compress&cs=tinysrgb&w=3200&fit=crop",
  lifestyle: "/assets/lifestyle.jpg",
  machine: "/assets/machine.jpg",
  gym: "https://images.pexels.com/photos/16513595/pexels-photo-16513595.jpeg",
  // Real brand assets from TheMacroBar
  chocHero: "/assets/choc_hero.jpg",
  mangoHero: "/assets/mango_hero.jpg",
  qr: "/assets/qr.jpg",
  beads: "/assets/decor_beads.png",
  molecule: "/assets/decor_molecule.png",
};

export const NAV_LINKS = [
  { label: "Why", href: "#manifesto" },
  { label: "Menu", href: "#menu" },
  { label: "How It Works", href: "#how" },
  { label: "The Machine", href: "#machine" },
];

export const CONTACT = {
  email: "vaibhavi@themacrobar.co.in",
  phone: "+91 70469 52006",
  phoneRaw: "+917046952006",
  instagram: "@the.macro.bar",
};

export const TAGWORDS = ["INSTANT", "HEALTHY", "TASTY"];

// Menu straight from the MacroBar deck
export const DRINKS = [
  {
    name: "Chocolate",
    line: "Macro Protein Shake",
    price: 299,
    macro: "30g Protein",
    kcal: "180 kcal",
    color: "#7B4B2A",
    img: "/assets/choc.jpg",
    desc: "Rich cocoa whey isolate blended thick and cold. The classic post-lift recovery hit.",
    serving: "300 ml",
    nutrition: [
      { label: "Calories", value: "180 kcal" },
      { label: "Protein", value: "30 g" },
      { label: "Carbs", value: "8 g" },
      { label: "of which sugar", value: "3 g" },
      { label: "Fat", value: "3 g" },
    ],
    ingredients: ["Filtered water", "Whey protein isolate", "Cocoa", "Skimmed milk", "Stevia leaf extract", "Sea salt"],
    allergens: "Contains milk. Made in a facility that handles nuts & soy.",
    span: "lg:col-span-7",
  },
  {
    name: "Mango",
    line: "Macro Protein Shake",
    price: 309,
    macro: "30g Protein",
    kcal: "185 kcal",
    color: "#F5A300",
    img: "/assets/mango.jpg",
    desc: "Alphonso mango meets fast whey. Bright, tropical, zero chalk.",
    serving: "300 ml",
    nutrition: [
      { label: "Calories", value: "185 kcal" },
      { label: "Protein", value: "30 g" },
      { label: "Carbs", value: "10 g" },
      { label: "of which sugar", value: "6 g" },
      { label: "Fat", value: "2.5 g" },
    ],
    ingredients: ["Filtered water", "Whey protein isolate", "Alphonso mango puree", "Skimmed milk", "Stevia leaf extract"],
    allergens: "Contains milk. Made in a facility that handles nuts & soy.",
    span: "lg:col-span-5",
  },
  {
    name: "Cold Coffee",
    line: "Macro Protein Shake",
    price: 349,
    macro: "25g Protein + Caffeine",
    kcal: "150 kcal",
    color: "#6F4A2E",
    img: "/assets/coffee.jpg",
    desc: "Chilled cold coffee blended with lean protein for a smooth, awake kind of fuel.",
    serving: "300 ml",
    nutrition: [
      { label: "Calories", value: "150 kcal" },
      { label: "Protein", value: "25 g" },
      { label: "Carbs", value: "12 g" },
      { label: "of which sugar", value: "7 g" },
      { label: "Fat", value: "3 g" },
      { label: "Caffeine", value: "80 mg" },
    ],
    ingredients: ["Cold brew coffee", "Milk", "Whey protein isolate", "Stevia leaf extract"],
    allergens: "Contains milk. Made in a facility that handles nuts & soy.",
    span: "lg:col-span-5",
  },
  {
    name: "Birthday Cake",
    line: "Macro Protein Shake",
    price: 349,
    macro: "28g Protein",
    kcal: "190 kcal",
    color: "#EAD3AE",
    img: "/assets/birthdaycake.jpg",
    desc: "Creamy vanilla birthday-cake shake with a hit of sprinkles. Dessert that trains with you.",
    serving: "300 ml",
    nutrition: [
      { label: "Calories", value: "190 kcal" },
      { label: "Protein", value: "28 g" },
      { label: "Carbs", value: "14 g" },
      { label: "of which sugar", value: "9 g" },
      { label: "Fat", value: "4 g" },
    ],
    ingredients: ["Milk", "Whey protein isolate", "Natural vanilla", "Birthday-cake flavour", "Stevia leaf extract"],
    allergens: "Contains milk. May contain gluten.",
    span: "lg:col-span-7",
  },
  {
    name: "Matcha",
    line: "Macro Matcha Shake",
    price: 289,
    macro: "Ceremonial Matcha",
    kcal: "150 kcal",
    color: "#8FB43A",
    img: "/assets/matcha.jpg",
    desc: "Smooth, stone-ground ceremonial matcha. Calm, clean energy without the jitters.",
    serving: "300 ml",
    nutrition: [
      { label: "Calories", value: "150 kcal" },
      { label: "Protein", value: "10 g" },
      { label: "Carbs", value: "14 g" },
      { label: "of which sugar", value: "8 g" },
      { label: "Fat", value: "4 g" },
      { label: "Caffeine", value: "45 mg" },
    ],
    ingredients: ["Milk", "Ceremonial-grade matcha", "Whey protein", "Stevia leaf extract"],
    allergens: "Contains milk.",
    span: "lg:col-span-7",
  },
  {
    name: "Blueberry",
    line: "Macro Iced Tea",
    price: 279,
    macro: "Antioxidant Rich",
    kcal: "90 kcal",
    color: "#C77A2B",
    img: "/assets/icedtea.jpg",
    desc: "Cold-brewed iced tea infused with blueberry. Light, refreshing, ridiculously easy.",
    serving: "350 ml",
    nutrition: [
      { label: "Calories", value: "90 kcal" },
      { label: "Protein", value: "0 g" },
      { label: "Carbs", value: "20 g" },
      { label: "of which sugar", value: "15 g" },
      { label: "Fat", value: "0 g" },
      { label: "Caffeine", value: "30 mg" },
    ],
    ingredients: ["Cold-brewed black tea", "Blueberry extract", "Lemon juice", "Cane sugar", "Filtered water"],
    allergens: "No major allergens. Vegan friendly.",
    span: "lg:col-span-5",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "THE CRASH",
    body: "The vending machine sold you sugar and a 3pm slump. Empty calories, empty promises. Wellness deserved better than a candy bar behind glass.",
  },
  {
    no: "02",
    title: "THE CURE",
    body: "Freshly blended protein, matcha, iced tea and cold coffee, dispensed in seconds. Real macros, real ingredients, chilled and ready when your body asks for fuel.",
  },
  {
    no: "03",
    title: "THE CONVENIENCE",
    body: "Placed where performance happens \u2014 gyms, offices, campuses. Choose, pay, collect. No queue, no barista, no excuses. Nutrition on demand, 24/7.",
  },
];

// The self-serve vending flow (from the MacroBar deck)
export const STEPS = [
  { no: "01", title: "CHOOSE", body: "Browse the menu on the touchscreen and pick your flavour \u2014 shake, matcha, iced tea or coffee." },
  { no: "02", title: "SCAN & PAY", body: "Scan the QR to pay instantly via UPI \u2014 GPay, PhonePe or Paytm. No cash, no cards." },
  { no: "03", title: "BLEND", body: "Take a pause. Your MacroDrink is flash-blended fresh, chilled and ready in seconds." },
  { no: "04", title: "COLLECT", body: "Grab your drink from the tray. Snap it, tag @the.macro.bar and enjoy." },
];
